"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePrivacyModalState = void 0;
const react_1 = require("react");
const get_is_bot_1 = __importDefault(require("./get-is-bot"));
const get_is_in_iframe_1 = require("./get-is-in-iframe");
const get_proxy_url_1 = __importDefault(require("./get-proxy-url"));
const storage_1 = __importDefault(require("./storage"));
const tracking_1 = require("./tracking");
const usePrivacyModalState = (isAnonymized) => {
    const { optIn } = (0, tracking_1.useTracking)();
    const isBot = (0, get_is_bot_1.default)();
    const isInIFrame = (0, get_is_in_iframe_1.getIsInIFrame)();
    const [privacyModalState, setPrivacyModalState] = (0, react_1.useState)(!isAnonymized && !isBot && !isInIFrame ? 'show' : undefined);
    (0, react_1.useEffect)(() => {
        let optInWatcher = null;
        if (!isBot && isInIFrame) {
            optInWatcher = setInterval(() => {
                const value = storage_1.default.getItem('MDRNA_AMPLITUDE');
                if (value === '1') {
                    optIn(true);
                }
                else if (value === '') {
                    optIn(false);
                }
            }, 1000);
        }
        return () => {
            if (optInWatcher) {
                clearInterval(optInWatcher);
            }
        };
    }, [isBot, isInIFrame, optIn]);
    (0, react_1.useEffect)(() => {
        if (isAnonymized && !isBot && !isInIFrame) {
            fetch(`${(0, get_proxy_url_1.default)()}/privacy-modal`)
                .then((response) => {
                if (!response.ok) {
                    throw new Error(`Error: ${response}`);
                }
                return response.text();
            })
                .then((state) => {
                if (state === 'hide') {
                    optIn(true);
                }
                setPrivacyModalState(state);
            })
                .catch(() => {
                setPrivacyModalState('show');
            });
        }
    }, [isAnonymized, isBot, isInIFrame, optIn]);
    return privacyModalState;
};
exports.usePrivacyModalState = usePrivacyModalState;
